<template>
  <div :class="$style.honor">
    <the-honor-tabs :data="navData" @change="handleChange" />
    <the-honor-list :data="honorList" />
  </div>
</template>

<script>
import TheHonorTabs from './TheHonorTabs'
import TheHonorList from './TheHonorList'

export default {
  components: { TheHonorTabs, TheHonorList },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return { active: 0 }
  },
  computed: {
    navData() {
      return this.data.map((el) => Number(el.year)) || []
    },
    honorList() {
      return (this.data[this.active] && this.data[this.active].honor_list) || []
    },
  },
  methods: {
    handleChange(index) {
      this.active = index
    },
  },
}
</script>

<style lang="less" module>
.honor {
  padding: @padding-base 0;
}
</style>
